import { logger } from '../datadog/datadog-log-wrapper';

export type ConsentDetails = {
  services: Record<string, ServiceData>;
  consent: {
    status: 'ALL_DENIED' | 'SOME_ACCEPTED' | 'ALL_ACCEPTED' | 'SOME_DENIED';
  };
};

type ServiceData = {
  name: string;
  version: string;
  category: string;
  essential: boolean;
  consent?: {
    given: boolean;
  };
};

export const SERVICE_ID = {
  userCentrics: 'H1Vl5NidjWX',
  segment: 'O97xcRJFR',
  amplitude: 'Sk9kb5VoOi-7',
  intercom: 'ryDQcVoOoZQ',
  googleAnalytics: 'HkocEodjb7',
  datadog: 'Xl0HIOViY',
  satisMeter: 'yLh46hLzDKkbmf',
  storyblok: 'jkQ9enxRQRt6VV',
  tandem: 'EWRpZPD0ucBq-H',
};

// return whether the consent has been given by the user for a specific service (from UserCentrics)
// the serviceId should be the same as in UserCentrics > data-processing-services page
export const getIsServiceConsentGiven = async (
  serviceId: keyof typeof SERVICE_ID,
): Promise<boolean> => {
  if (window.__ucCmp) {
    try {
      const consent: ConsentDetails = await window.__ucCmp.getConsentDetails();
      const serviceConsent = consent.services[SERVICE_ID[serviceId]];
      if (serviceConsent?.consent) {
        return serviceConsent.consent.given;
      }
    } catch {
      logger.warn('Error while getting UserCentrics consent details', {
        team: 'customer-operations',
        scope: 'consent-management',
        serviceId,
      });
    }
  }
  return appConfig.environmentName !== 'production'; // default value is true for all dev env for testing purposes
};
